import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { ProfileNoPurchase, Plus } from "src/components";
import { StringService, _ } from "src/services";
import { ProfileData, ProfileDataAction } from "src/store";

export const ProfilePurchases: React.FC = () => {

    //#region Dependencies

    const dispatch = useDispatch();
    const user: ProfileData = useSelector((state: any) => state.ProfileDataState);

    //#endregion

    //#region properties

    const packages = user.packages;

    //#endregion

    //#region mehtods

    const fetchData = useCallback((reset: boolean) => {

        if (packages.loading) return;

        dispatch(ProfileDataAction.getUserPackages(packages.count, reset ? 0 : packages.offset));
    }, [dispatch, packages]);

    const loadMore = useCallback(() => fetchData(false), [fetchData]);

    const copy = (text?: string | null) => {
        if (navigator.clipboard) {
            navigator.clipboard.writeText("" + text);
            toast.success(_("giftCodeCopied"));
        }
        else {
            toast.error(_("giftCodeNotCopied"));
        }
    };

    //#endregion

    //#region effects

    useEffect(() => {
        fetchData(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //#endregion

    //#region  helpers

    const renderLoadMore = () => {

        if (!packages.hasMore || packages.totalRecords <= packages.list.length || packages.offset >= packages.totalRecords) return null;


        if (packages.list.length > 0 && !packages.loading) {
            return (
                <div className="d-flex justify-content-center align-items-center h-4">
                    <button onClick={loadMore} className="db-block btn btn-link load-more-purchases"><Plus /> {_("showMore")}</button>
                </div>
            );
        }

        return null;
    };

    //#endregion

    if (!packages.loading && !packages.firstLoad && (!packages.list || packages.list.length === 0)) {
        return (<ProfileNoPurchase />);
    }

    return (
        <>
            <div className="profile-table">
                <table>
                    <thead>
                        <tr>
                            <td style={{ minWidth: 150 }}>{_("packageType")}</td>
                            <td style={{ minWidth: 120 }}>{_("giftCodeOrLink")}</td>
                            <td style={{ minWidth: 90 }}>{_("purchaseDate")}</td>
                            <td style={{ minWidth: 80 }}>{_("packageDuration")}</td>
                            <td style={{ minWidth: 80 }}>{_("subscriptionPrice")}</td>
                            <td style={{ minWidth: 80 }}>{_("subscriptionPayedPrice")}</td>
                            <td style={{ minWidth: 70 }}>{_("start")}</td>
                            <td style={{ minWidth: 70 }}>{_("end")}</td>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            user.packages.list.map((x, index) => (
                                <tr key={index}>
                                    <td>{x.title}{x.partner && (" + " + x.partner.productName + " " + x.partner.partnerName)}</td>
                                    <td>
                                        {!x.gift?.has && "-"}
                                        {
                                            x.gift.has && !!x.gift.code &&
                                            <span className="clickable"
                                                style={{ color: x.partner?.colorCode || "#00d17e" }}
                                                onClick={() => copy(x.gift.code)}>
                                                {x.gift.code}
                                            </span>
                                        }
                                        {
                                            x.gift.has && !!x.gift.link &&
                                            <a href={x.gift.link} style={{ color: x.partner?.colorCode || "#00d17e" }}
                                                target="_blank" rel="noopener noreferrer">{x.gift.title}</a>
                                        }
                                    </td>
                                    <td>{x.paidOn}</td>
                                    <td>{x.durationType}</td>
                                    <td>{StringService.toPrice(x.payableAmount)} تومان</td>
                                    <td>{StringService.toPrice(x.payableTaxAmount)} تومان</td>
                                    <td>{x.startedOn}</td>
                                    <td>{x.endedOn}</td>
                                </tr>
                            ))
                        }
                        {
                            user.packages.loading &&
                            [...new Array(10)].map((x, index) => (
                                <tr key={index}>
                                    <td><span className="shimmer"></span></td>
                                    <td><span className="shimmer"></span></td>
                                    <td><span className="shimmer"></span></td>
                                    <td><span className="shimmer"></span></td>
                                    <td><span className="shimmer"></span></td>
                                    <td><span className="shimmer"></span></td>
                                    <td><span className="shimmer"></span></td>
                                    <td><span className="shimmer"></span></td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>
            {renderLoadMore()}
        </>
    );

};